<template>
  <div class="Man-Informatica-Principal">
    <PageTitle
      icon="fa fa-bar-chart"
      main="Indicadores informática"
      sub="KPI"
    />
    <div class="Man-Informatica-Principal">
      <b-card no-body>
        <b-tabs>
          <b-tab title="Utilização App´s" active><InformaticaPainel /></b-tab>
          <b-tab title="Usuários"><FuncionarioPainel /></b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import InformaticaPainel from "../informatica/InformaticaPainel";
import FuncionarioPainel from "../informatica/FuncionarioPainel";

export default {
  name: "InformaticaPrincipal",
  components: {
    PageTitle,
    InformaticaPainel,
    FuncionarioPainel,
  },
};
</script>

<style>
</style>







